import { formatDateToInputString } from "../../helpers/date.helpers";

export const InlineDatePicker = ({ 
  value, 
  onChange 
}: { 
  value: Date | null,
  onChange: (date: Date | null) => void 
}) => {
  return (
    <input
      type="date"
      value={formatDateToInputString(value)}
      onChange={(e) => onChange(e.target.value ? new Date(`${e.target.value}T00:00:00`) : null)}
      className="block w-full rounded-md border-0 bg-white p-1.5 text-zinc-900 shadow-sm ring-1 ring-inset ring-zinc-300 placeholder:text-zinc-400 focus:ring-2 focus:ring-inset focus:ring-zinc-600 dark:bg-zinc-950 dark:text-white dark:ring-white/10 dark:placeholder:text-zinc-500 dark:focus:ring-white/20 sm:text-sm sm:leading-6"
    />
  );
};